<template>

  <div class="main-container">

    <section  class="container mt-0 pt-0">

          <div class="row m-0 pb-3 p-0 bg-white">
            
            <div class="col-12 col-md-6 offset-md-3 mt-5">

              <div class="row mb-3">

                <div class="col-4">
                  <img src="../assets/chipin-emblem.png" alt="" height="120" width="120" class="img-fluid circle">
                </div>

                <div class="pl-0 col-8">
                  <p class="font-weight-normal mb-1 mt-2 mb-0 pb-0 dark-text h5">Why is music not free?</p>
                  <p class="font-weight-light mb-1">Subscribing to an Artist shows your appreciation of the music you love to listen to.</p>
                </div>
              </div>

            </div>

            <div id="chipin-form" class="col-12 col-md-6 offset-md-3 mt-2">

              <p class="text-left font-weight-light pt-0 mt-0 mb-0">Making a living from music is hard. Artist royalties from streaming platforms alone are incredibly low and require huge global popularity just to make a living. Trackd is changing that. </p>

              <p class="text-left font-weight-light py-2 mb-0">We’re giving the power back to Artists who can choose what to offer their fans for free or included with a subscription. </p>

              <p class="text-left font-weight-light py-2 mb-0">Subscribe today and support this Artist to be more creative than ever before.</p>
              
              <p class="text-center mt-3 pt-3">
                <b-button class="mb-4 px-5 py-2 rounded-btn" size="md" block variant="info" @click="back()">
                  &nbsp;&nbsp;&nbsp;&nbsp;Back&nbsp;&nbsp;&nbsp;&nbsp;
                </b-button>
              </p>

            </div>


        </div>

      </section>

  </div>
  
</template>

<script>

  export default {
    name: 'ChipInTellMeMore',
    methods: {
      back() {
        this.$router.push('/')
      }
    }
  }
  
</script>

<style scoped>

  .light-grey-border {
    border: 2px solid #9B9B9B
  }

  .red-text {
    color: #FF0000;
  }
  
  .dark-text {
    color: #595959;
  }

  .super-small {
    font-size: 0.7em;
    color: #595959;
  }

  .rounded-btn {
    border-radius: 10px;
  }

</style>